"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _video = _interopRequireDefault(require("video.js"));
require("video.js/dist/video-js.css");
require("videojs-hls-quality-selector");
var _defaultVolume = require("../../constants/defaultVolume");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var VideoPlayer = function VideoPlayer(_ref) {
  var options = _ref.options,
    videoUrl = _ref.videoUrl;
  var playerRef = (0, _react.useRef)(null);

  // Determine the video source type based on the video URL
  var videoSourceType = videoUrl !== null && videoUrl !== void 0 && videoUrl.includes('.m3u8') ? 'application/x-mpegURL' : 'video/mp4';
  var videoJsOptions = _objectSpread(_objectSpread({}, options), {}, {
    techOrder: ['html5'],
    html5: {
      vhs: {
        overrideNative: true,
        useDevicePixelRatio: true,
        // Favor sharper video on high-DPI
        enableLowInitialPlaylist: false,
        // Start with higher bitrate
        limitRenditionByPlayerDimensions: false,
        // allow the highest resolution
        bandwidth: 10000000,
        // Start with a high bandwidth estimate to avoid low-quality initial playback aka 10 Mbps
        useNetworkInformationApi: false // Disable adaptive bitrate based on network conditions as it causes issues with broadcast recorder
      }
    },
    sources: [{
      src: videoUrl,
      type: videoSourceType
    }]
  });

  // Initialize video.js player once the component is mounted
  (0, _react.useEffect)(function () {
    var player = playerRef.current;
    if (player) {
      var videoPlayer = (0, _video["default"])(player, videoJsOptions);
      videoPlayer.ready(function () {
        videoPlayer.volume(_defaultVolume.DEFAULT_VOLUME);
        videoPlayer.hlsQualitySelector({
          displayCurrentQuality: true
        });
      });
      return function () {
        if (videoPlayer) {
          videoPlayer.dispose();
        }
      };
    }
  }, [videoUrl]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-vjs-player": true
  }, /*#__PURE__*/_react["default"].createElement("video", {
    ref: playerRef,
    className: "video-js vjs-default-skin vjs-big-play-centered"
  }, "Your browser does not support the video file."));
};
var _default = exports["default"] = VideoPlayer;